import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { NavController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class SellerGuard implements CanActivate {
  constructor(private navCtrl: NavController) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const idSeller = route.params['idSeller'];
    const userDB = localStorage.getItem("userDB");
    const seller = JSON.parse(userDB);
    const userId = seller?.user?.id || seller?.id || seller?.idUser || seller?.uuid;
    if (userId !== idSeller) {  
      this.navCtrl.navigateRoot("home");
      return false;
    }
    return true; 
  }
}
